import React, { useState } from 'react';

export default function PasswordField({ value, onChange, mode, config, ...props }) {
    const [showPassword, setShowPassword] = useState(false);
    
    if (mode === "view") return <span>••••••••</span>;
    
    return (
        <div className="input-group">
            <input 
                type={showPassword ? "text" : "password"} 
                value={value || ""} 
                onChange={e => onChange(e.target.value)} 
                className="form-control"
                placeholder="Enter password"
                {...props}
            />
            <button 
                type="button" 
                className="btn btn-outline-secondary"
                onClick={() => setShowPassword(!showPassword)}
            >
                {showPassword ? "Hide" : "Show"}
            </button>
        </div>
    );
} 